import { createContext, useContext, useEffect, useState, type ReactNode } from "react";
import { collection, onSnapshot } from "firebase/firestore";
import {
  COL_PIPELINE_USERS,
  TEAM,
  mergeDirectory,
  type PipelineUser,
  type TeamMember,
} from "@closing/shared";
import { db } from "./firebase";

/**
 * Live team directory: the hardcoded seed merged with everyone in the shared
 * pipeline-users collection (anyone who has signed into a cv-priorities
 * tool). One snapshot listener app-wide; assignee pickers read from context.
 */
const Ctx = createContext<TeamMember[]>(TEAM);

export function DirectoryProvider({ children }: { children: ReactNode }) {
  const [directory, setDirectory] = useState<TeamMember[]>(mergeDirectory([]));

  useEffect(() => {
    return onSnapshot(collection(db, COL_PIPELINE_USERS), (snap) => {
      const live = snap.docs
        .map((d) => d.data() as PipelineUser)
        .filter((u) => u.email)
        .map((u) => ({
          displayName: u.displayName ?? u.email,
          email: u.email,
          photoURL: u.photoURL ?? null,
        }));
      setDirectory(mergeDirectory(live));
    });
  }, []);

  return <Ctx.Provider value={directory}>{children}</Ctx.Provider>;
}

export function useDirectory(): TeamMember[] {
  return useContext(Ctx);
}
